<wsd-extended-card
  [loading]="!(safeFromHarm$ | async)"
  [title]="'DATA_PORTAL.SAFE_FROM_HARM.TITLE' | translate">

  <div *ngIf="safeFromHarm$ | async as data">

    <div class="text-center">
      <span class="numbers primary-color">
        {{ data.contactPersonCount + '/' + data.organizationCount  }}
      </span>
      <p class="mt-5">{{ 'DATA_PORTAL.SAFE_FROM_HARM.CONTACT_PERSON' | translate }}</p>
    </div>

    <div class="text-center m-t-5">
      <span class="numbers primary-color">
        {{ data.sfhPolicyCount + '/' + data.organizationCount  }}
      </span>
      <p class="mt-5"> {{ 'DATA_PORTAL.SAFE_FROM_HARM.POLICY' | translate }}</p>
    </div>

    <div class="text-center m-t-5">
      <span class="numbers primary-color">
        {{ data.sfhReportCount + '/' + data.organizationCount  }}
      </span>
      <p class="mt-5"> {{ 'DATA_PORTAL.SAFE_FROM_HARM.REPORT' | translate }}</p>
    </div>
  </div>

</wsd-extended-card>
